<template>
  <el-container class="home">
    <el-header>
      <div class="header_left">{{companyName}}</div>
      <ul class="header_right" style="width:320px;">
        <el-dropdown class="username"  @command="handleCommand">
          <span class="el-dropdown-link">
            {{username}}
            <i class="el-icon-caret-bottom"></i>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="modifyPwd">修改密码</el-dropdown-item>
              <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>  
        <modifyPwdDialog 
          :modifyPwdFlg="modifyPwdFlg"
          @modifyPwdFialog-flg="getModifyPwd"/>  
        <!--
        <li>
          <span>{{username}}</span>
        </li>
        <li @click="logout">
          <span>退出</span>
        </li>-->
      </ul>
      <ul class="date_wrap">
        <li style="font-size:12px">
          <div>{{weekDate}}</div>
          <div>{{yearDate}}</div>
        </li>
        <li style="font-size:34px">{{timeDate}}</li>
      </ul>
    </el-header>
    <el-container>
      <el-aside width="218px">
        <el-menu
          default-active="activePath"
          text-color="#697b86"
          active-text-color="#409EFF"
          unique-opened
          router
        >
          <el-submenu :index="item.id" v-for="item in meunlist" :key="item.id">
            <template slot="title">
              <i :class="iconObj[item.id]" style="color:sykblue"></i>
              <span>{{item.authName}}</span>
            </template>
            <el-menu-item
              :index=" '/' + childItem.path"
              v-for="childItem in item.child"
              :key="childItem.id"
              @click="saveChildPath('/' + childItem.path)"
            >
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">{{childItem.authName}}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import modifyPwdDialog from '../components/passwordModifyDialog'
import waterSupplyMonitor from "../components/waterSupplyMonitor.vue";
export default {
  components: {
    modifyPwdDialog
  },
  data() {
    return {
      iconObj: {
        "0": "el-icon-user",
        "6": "el-icon-s-tools",
        "1": "el-icon-map-location",
        "2": "el-icon-tickets",
        "3": "el-icon-error",
        "4": "el-icon-user",
        '5': 'el-icon-phone-outline'
      },
      meunlist: [
        {
          id: "4",
          authName: "单位管理",
          path: "company",
          child: [{ id: "14", authName: "用户列表", path: "company" }]
        },
        {
          id: "0",
          authName: "用户管理",
          path: "user",
          child: [{ id: "10", authName: "用户列表", path: "user" }]
        },
        {
          id: "2",
          authName: "水表管理",
          path: "water",
          child: [{ id: "12", authName: "水表列表", path: "water" }]
        },
        {
          id: "1",
          authName: "区域管理",
          path: "area",
          child: [
            { id: "11", authName: "区域列表", path: "area" },
            { id: "21", authName: "每日统计", path: "dayreport" }
            ]
        },
        {
          id: "3",
          authName: "故障管理",
          path: "area",
          child: [
            { id: "13", authName: "新申报故障", path: "newerror" },
            { id: "23", authName: "处理中故障", path: "workingerror" },
            { id: "33", authName: "已完成故障", path: "enderror" }
          ]
        },
        {id: '5', authName: "制度编辑", path: "area",
          child:[{id: '15', authName: "制度编辑", path: "regime"}]
        }, 
      ],
      activePath: "",
      weekDate: "",
      yearDate: "",
      timeDate: "",
      username: "",
      companyName:'',
      modifyPwdFlg: false,
    };
  },
  created() {
    this.activePath = window.sessionStorage.getItem("activePath");

    // 动态加载时间
    const timer = setInterval(() => {
      this.getNowTime();
    }, 500);
    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });
    this.getMeunList();
    // 显示星期几
    let weekDay = ["日", "一", "二", "三", "四", "五", "六"];
    let weekNum = new Date().getDay();
    this.weekDate = "星期" + weekDay[weekNum];
    this.username = sessionStorage.getItem("name");
    var issys = sessionStorage.getItem("issys");
    this.companyName = '欧雅陶瓷后台管理系统';
    
  },
  methods: {
    getNowTime() {
      const dt = new Date();
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      this.yearDate = `${y}-${m}-${d}`;
      this.timeDate = `${hh}:${mm}`;
    },
    goFullScreen() {
      this.$router.push("/index");
    },
    logout() {
      sessionStorage.clear();
      this.$router.push("/login");
    },
    handleCommand(command) {
      if (command == 'loginout') {
        sessionStorage.clear();
        this.$router.push('/login')
      } else {
        this.modifyPwdFlg = true
      }
    },       
    getModifyPwd(val) {
      this.modifyPwdFlg = val;
      console.log(val);

    },
    saveChildPath(activePath) {
      window.sessionStorage.setItem("activePath", activePath);
      this.activePath = activePath;
    },
    getMeunList() {
      var issys = parseInt(sessionStorage.getItem("issys"));
      if (isNaN(issys)) {
        issys = 0;
      }
      if (issys == 1) {
        this.meunlist = [
          {
            id: "4",
            authName: "单位管理",
            path: "company",
            child: [
              { id: "14", authName: "用户列表", path: "company" },
              { id: "24", authName: "链接列表", path: "link" },
              { id: "34", authName: "FTP列表", path: "ftp" }
            ]
          }
        ];
      } else {
        this.meunlist = [
          {
            id: "0",
            authName: "系统管理",
            path: "user",
            child: [{ id: "19", authName: "用户列表", path: "user" }]
          },
          {
            id: "2",
            authName: "产品管理",
            path: "company",
            child: [
              { id: "11", authName: "产品规格", path: "guige" },
              { id: "13", authName: "产品材质", path: "caizhi" },
              { id: "14", authName: "产品颜色", path: "yanse" },
              { id: "15", authName: "产品光泽度", path: "guangzedu" },
              { id: "16", authName: "产品工艺", path: "gongyi" },
              { id: "17", authName: "产品列表", path: "product" },
              { id: "18", authName: "首页轮播图", path: "bannar" },
              { id: "19", authName: "精选案例", path: "tuijian" }
            ]
          }, {
            id: "6",
            authName: "公司信息",
            path: "company",
            child: [{ id: "61", authName: "公司信息", path: "company" }]
          }, {
            id: "5",
            authName: "联系客户",
            path: "contact",
            child: [{ id: "51", authName: "联系客户", path: "contact" }]
          }
        ];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    height: 100%;
    .el-header {
      background-color: #0091ea;
      color: #FFF;
      width: 100%;
      height: 60px;
      .header_left {
        float: left;
        cursor: pointer;
        width: 260px;
        line-height: 60px;
        margin-left: 30px;
        font-family: "微软雅黑";
        color: #f7fafe;
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 0.1em;          
      }
      .header_right {
        // background-color: pink;
        width: 300px;
        float: right;
        color: #f7fafe;
        font-size: 14px;
        >li {
          line-height: 60px;
          font-weight: 600;
          float: left;
          padding: 0 10px;
          cursor: pointer;
          >i {
            font-size: 22px;
            vertical-align: -4px;
          }
          >span {
            display: inline-block;
            line-height: 60px;
            padding: 0 4px;
          }
        }
        .active,
        >li:hover {
          padding: 0 10px;
          background-color: #337ab7;
          border-radius: 4px;
        }
        .username {
          float: left;
          padding-top: 20px;
          .el-dropdown {
            display: inline-block;
          }
          .el-dropdown-link {
            color: #dedede;
            cursor: pointer;
          }

        }        
      }
      .date_wrap {
        font-family: "clock";
        opacity: 0.7;
        float: right;
        width: 260px;
        height: 100%;
        >li {
          float: left;
        }
        >:nth-child(1) {
          line-height: 46px;
          >div {
            height: 16px;
          }
        }
        >:nth-child(2) {
          line-height: 60px;
          padding-left: 6px;
          font-weight: 700;
        }         
      }


    }
    
    .el-aside {
      box-shadow: 4px 4px 10px rgba(69,65,78,.16);
      //  box-shadow: 0 0 0 1px hsla(0,0%,100%,.3) inset,   
      //              0 .5em 1em rgba(0, 0, 0, 0.6);  
      .el-menu {
        border-right: 0;
      }
    }
  }

</style>